import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al2013',
    ecrans: ['00-2']
});
